var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-06-28
 * @brief SEI 운영관리 - 기기등록 수정 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
// recoil
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, curAdminTreeState } from "../../../../recoil/assessmentState";
import { loadingBoxState } from "../../../../recoil/menuState";
import { infoPop, reLoad, reLoadState, userInfoLoginState } from "../../../../recoil/userState";
// utils
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
// datepicker
import dayjs from "dayjs";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { langId } from "../../../../recoil/langState";
import { useTrans } from "../../../../utils/langs/useTrans";
// component
/**
 * @brief EHP 운영 관리 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
function EquipmentEdit(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const reload = useRecoilValue(reLoad);
    const [infoPopId, setInfoPopId] = useRecoilState(infoPop);
    const [image, setImages] = useState([]);
    const langIds = useRecoilValue(langId);
    // props
    const { handleOpenPop, deviceInfo, is1650M } = props;
    const [editReload, setEditReload] = useState(false);
    const [itemInfo, setItemInfo] = useState(null);
    useEffect(() => {
        // 수정
        handleOpenPop("pop-edit-info", _jsx(DeviceEditPop, { itemInfo: itemInfo, editReload: editReload, setEditReload: setEditReload, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.수정") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => EditClose("pop-edit-info") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 삭제
        handleOpenPop("pop-delete-image", _jsx(DeletePop, { itemInfo: itemInfo }));
    }, [itemInfo, editReload]);
    function EditClose(id) {
        setEditReload(true);
        CUTIL.jsclose_Popup(id);
        CUTIL.IdScrollIntoView(id, "form__input");
    }
    // width 1650 상세정보 팝업
    if (is1650M) {
        const infoPop = document.getElementById(infoPopId);
        if (!CUTIL.isnull(infoPop)) {
            infoPop.classList.remove("m-hidden");
            infoPop.classList.add("popup-layer");
            infoPop.classList.add("js-layer");
            infoPop.classList.add("popup-type1");
            infoPop.setAttribute("style", `position: fixed; top:0; right:0 `);
        }
    }
    else {
        closePopup(infoPopId);
    }
    // 이미지 가져오기
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/images/item`,
        appQuery: {
            itemId: deviceInfo.itemId,
        },
        userToken: userInfo.loginInfo.token,
        watch: deviceInfo.itemId + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setImages(data.body);
            }
            else {
                // need error handle
            }
        }
    }, [data, langIds]);
    // 상세 정보 닫기
    function closePopup(id) {
        const infoPop = document.getElementById(id);
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(infoPop)) {
            infoPop.classList.add("m-hidden");
            infoPop.classList.remove("popup-layer");
            infoPop.classList.remove("js-layer");
            infoPop.classList.remove("popup-type1");
            infoPop.removeAttribute("style");
            if (!CUTIL.isnull(body))
                body.removeAttribute("style");
            if (!CUTIL.isnull(dimm))
                dimm.removeAttribute("style");
            setInfoPopId("");
            return;
        }
    }
    // 이미지 다운로드
    function onClicFileDown(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            HTTPUTIL.fileDownload2(`${itemId.name}`, itemId.url);
        });
    }
    function EditOpen(e) {
        setEditReload(false);
        setItemInfo(deviceInfo);
        CUTIL.jsopen_Popup(e);
    }
    return (_jsx(_Fragment, { children: deviceInfo && (_jsxs("article", Object.assign({ className: "box box-detailinfo m-hidden", id: "m-1650" }, { children: [_jsxs("div", Object.assign({ className: "box__header" }, { children: [_jsx("p", Object.assign({ className: "box__title bg-no" }, { children: deviceInfo.itemName })), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => closePopup("m-1650") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsxs("section", { children: [_jsxs("div", Object.assign({ className: "section-top mb-8" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.설비정보") })), _jsxs("div", Object.assign({ className: "right" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-edit-info", onClick: (e) => EditOpen(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete-image", onClick: (e) => EditOpen(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }))] })), _jsx("div", Object.assign({ className: "section-bottom" }, { children: _jsx("div", Object.assign({ className: "tbl-list row" }, { children: _jsxs("table", Object.assign({ summary: "\uC124\uBE44\uC720\uD615,\uBD84\uC804\uC18C \uBA85,\uD615 \uBA85,\uD310\uB12C \uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uC81C\uC870\uC0AC,\uC81C\uC870\uB144\uC6D4,\uC815\uACA9\uC804\uC555(Elec info 1),\uC815\uACA9\uC804\uC555(Elec info 2),\uC815\uACA9\uC804\uC555(Elec info 3),\uC815\uACA9\uC804\uC555(Elec info 4) \uD56D\uBAA9\uC73C\uB85C \uC124\uBE44 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC124\uBE44 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "40%" } }), _jsx("col", { style: { width: "60%" } })] }), _jsxs("tbody", { children: [_jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.설비유형") })), _jsx("td", { children: deviceInfo.companySpg.spgName ? deviceInfo.companySpg.spgName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.분전소명") })), _jsx("td", { children: deviceInfo.roomName })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.형명") })), _jsx("td", { children: deviceInfo.itemName ? deviceInfo.itemName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.판넬명") })), _jsx("td", { children: deviceInfo.panel.panelName ? deviceInfo.panel.panelName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.시리얼번호") })), _jsx("td", { children: deviceInfo.serialNo ? deviceInfo.serialNo : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.제조사") })), _jsx("td", { children: deviceInfo.manufacturer ? deviceInfo.manufacturer : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.제조년월") })), _jsx("td", { children: deviceInfo.madeyyyyMM ? dayjs(deviceInfo.madeyyyyMM).format("YYYY-MM") : "-" })] }), deviceInfo.elecInfos.map((list, idx) => (_jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "row" }, { children: [list.name, _jsx("br", {}), "(", list.code, ")"] })), _jsxs("td", { children: [list.value == null ? "-" : list.value, " ", list.unit, " "] })] }, "infos_" + idx.toString()))), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.메모") })), _jsx("td", { children: deviceInfo.memo ? deviceInfo.memo : "-" })] })] })] })) })) }))] }), _jsxs("section", { children: [_jsxs("div", Object.assign({ className: "section-top mb-8" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.첨부파일") })), _jsx("div", { className: "right" })] })), _jsx("div", Object.assign({ className: `section-bottom ${image.length <= 0 ? "nodata" : ""}` }, { children: _jsxs("div", Object.assign({ className: "tbl-list row" }, { children: [_jsxs("table", Object.assign({ summary: "\uD615\uBA85,\uD310\uB12C \uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uC81C\uC870\uC0AC,\uC81C\uC870\uB144\uC6D4,\uC804\uAE30\uC2E4 \uBA85,\uC815\uACA9\uC804\uC555,2\uCC28 \uC804\uC555,\uC815\uACA9\uC804\uB958,\uCC28\uB2E8\uC804\uB958,\uC815\uACA9\uC6A9\uB7C9 \uD56D\uBAA9\uC73C\uB85C \uC124\uBE44 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC124\uBE44 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8" }), _jsx("tbody", { children: _jsx("tr", { children: _jsx("td", { children: _jsx("ul", Object.assign({ className: "filelist" }, { children: image.map((img, idx) => (_jsx("li", { children: _jsx("span", Object.assign({ style: { cursor: "pointer" }, onClick: (e) => onClicFileDown(img) }, { children: img.name })) }, "img " + idx.toString()))) })) }) }) })] })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("운영관리.NODATA.첨부파일") }))] })) }))] })] }))] }))) }));
}
export default EquipmentEdit;
function DeviceEditPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTree = useRecoilValue(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [reload, setReload] = useRecoilState(reLoad);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const langIds = useRecoilValue(langId);
    const { itemInfo, editReload, setEditReload } = props;
    // useState
    const [spgInfo, setSpgInfo] = useState([]);
    const [spg, setSpg] = useState(null);
    const [elecInfo, setEleInfo] = useState([]);
    const [elecInfoItem, setEleInfoItem] = useState([]);
    const [itemName, setItemName] = useState("");
    const [panelName, setPanelName] = useState("");
    const [serialNo, setSerialNo] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [memo, setMemo] = useState("");
    const [today, setToday] = useState("");
    const [file, setFile] = useState([]);
    const [updateFile, setUpdateFile] = useState([]);
    const [errorList, setErrorList] = useState([]);
    const [reloadState, setReloadState] = useRecoilState(reLoadState);
    const lastNum = 10;
    useEffect(() => {
        if (elecInfoItem.length > 0) {
            const listArr = elecInfo.concat(elecInfoItem[0]).sort((a, b) => (a.sort > b.sort ? 1 : -1));
            const elecInfoListArr = (data) => {
                const uniqueItems = new Set();
                return data.filter((item) => {
                    const itemString = JSON.stringify(item);
                    if (uniqueItems.has(itemString)) {
                        return false;
                    }
                    else {
                        uniqueItems.add(itemString);
                        return true;
                    }
                });
            };
            // 중복 제거된 데이터
            const uniqueData = elecInfoListArr(listArr);
            setEleInfo(uniqueData);
        }
    }, [elecInfoItem.length]);
    // spg select
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/company/${recoilTree.company.companyId}/spgs`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: reload + langIds.toString(),
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSpgInfo(data.body);
                if (itemInfo || editReload) {
                    // setSpg(itemInfo.companySpg);
                    setItemName(itemInfo.itemName);
                    setPanelName(itemInfo.panel.panelName);
                    setSerialNo(itemInfo.serialNo);
                    setManufacturer(itemInfo.manufacturer);
                    setMemo(itemInfo.memo);
                    setToday(itemInfo.madeyyyyMM ? itemInfo.madeyyyyMM.replace(/(\d{4})(\d{2})/, "$1-$2") : "");
                    Images(itemInfo.itemId);
                    setEditReload(false);
                    setErrorList([]);
                    setEleInfo([]);
                    setEleInfoItem([]);
                    onClickSpg(itemInfo.companySpg, itemInfo.elecInfos);
                    /* if (langIds < 2) {
                      setEleInfo(
                        itemInfo.elecInfos.map((item) => ({
                          ...item,
                          elecInfoName: item.name,
                          companyElecId: item.id,
                        }))
                      );
                    } else {
                      setEleInfo(
                        itemInfo.elecInfos.map((item) => ({
                          ...item,
                          elecInfoNameEnglish: item.name,
                          companyElecId: item.id,
                        }))
                      );
                    } */
                }
            }
            else {
                // need error handle
            }
        }
    }, [data, itemInfo, editReload, langIds]);
    function Images(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/images/item?itemId=${itemId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setUpdateFile(data.body);
                }
                else {
                    // alert(data.errorList.map((err) => (err.msg)));
                }
            }
        });
    }
    let ImageUi = [...updateFile, ...file];
    // spg select 후 전력 정보 추출
    function onClickSpg(val, list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${val.companySpgId}/elecinfos/type`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (list) {
                        // data1의 value를 data2의 selectedUnit에 넣기
                        const updatedData2 = data.body.map((item2, idx) => {
                            const matchingItem1 = list.find((item1) => item1.code === item2.code);
                            if (matchingItem1) {
                                return Object.assign(Object.assign({}, item2), { value: matchingItem1.value, checked: matchingItem1.unit === null ? true : false, idx: idx, unit: item2.type < 2
                                        ? item2.unit
                                        : item2.unit.map((value, index) => ({
                                            name: value,
                                            selected: false,
                                            id: idx,
                                            unitId: value[0] + index,
                                        })), unitEn: item2.type < 2
                                        ? item2.unitEn
                                        : item2.unitEn.map((value, index) => ({
                                            name: value,
                                            selected: false,
                                            id: idx,
                                            unitEnId: value[0] + index,
                                        })) });
                            }
                            return item2;
                        });
                        setEleInfo(updatedData2);
                        updatedData2
                            .filter((val) => val.checked && val.value)
                            .map((element) => __awaiter(this, void 0, void 0, function* () {
                            yield ElecInfo(val.companySpgId, element, list);
                        }));
                    }
                    else {
                        setEleInfo(data.body.map((item, idx) => (Object.assign(Object.assign({}, item), { value: item.type < 2 ? "" : langIds < 2 ? item.unit[0] : item.unitEn[0], idx: idx, 
                            // uiType: item.type,
                            unit: item.type < 2
                                ? item.unit
                                : item.unit.map((value, index) => ({
                                    name: value,
                                    selected: false,
                                    id: idx,
                                    unitId: value[0] + index,
                                })), unitEn: item.type < 2
                                ? item.unitEn
                                : item.unitEn.map((value, index) => ({
                                    name: value,
                                    selected: false,
                                    id: idx,
                                    unitEnId: value[0] + index,
                                })), checked: false }))));
                    }
                    setSpg(val);
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    // elecInfo type2
    function onClickElecInfo(item, list, id, unitId, blooean) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${spg.companySpgId}/elecinfos/type`,
                appQuery: {
                    name: list.name,
                    elecCode: item.code,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    let itemArr = elecInfo.map((smenu) => smenu.code === item.code
                        ? Object.assign(Object.assign({}, smenu), { checked: true, value: list.name, unit: smenu.type < 2
                                ? smenu.unit
                                : smenu.unit.map((item) => item.id === id ? Object.assign(Object.assign({}, item), { selected: item.unitId == unitId ? true : false }) : item), unitEn: smenu.type < 2
                                ? smenu.unitEn
                                : smenu.unitEn.map((item) => item.id === id ? Object.assign(Object.assign({}, item), { selected: item.unitId == unitId ? true : false }) : item) }) : smenu);
                    const selcetItem = data.body.map((item) => (Object.assign(Object.assign({}, item), { value: "", 
                        // uiType: 3,
                        id: id })));
                    const listArr = itemArr.concat(selcetItem).sort((a, b) => (a.sort > b.sort ? 1 : -1));
                    const elecInfoListArr = (data) => {
                        const uniqueItems = new Set();
                        return data.filter((item) => {
                            const itemString = JSON.stringify(item);
                            if (uniqueItems.has(itemString)) {
                                return false;
                            }
                            else {
                                uniqueItems.add(itemString);
                                return true;
                            }
                        });
                    };
                    // 중복 제거된 데이터
                    const uniqueData = elecInfoListArr(listArr);
                    if (blooean) {
                        const dataArr = uniqueData.filter((item) => item.id !== id);
                        const changeData = dataArr.concat(selcetItem).sort((a, b) => (a.sort > b.sort ? 1 : -1));
                        setEleInfo(changeData);
                    }
                    else {
                        setEleInfo(uniqueData);
                    }
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    //팝업 시작시 첫 매핑옵션 가져오기
    function ElecInfo(companySpgId, list, value) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${companySpgId}/elecinfos/type`,
                appQuery: {
                    name: list.value,
                    elecCode: list.code,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    const listData2 = data.body.map((item2) => {
                        const matchingItem1 = value.find((item1) => item1.code === item2.code);
                        if (matchingItem1) {
                            return Object.assign(Object.assign({}, item2), { value: matchingItem1.value, id: list.idx });
                        }
                        return item2;
                    });
                    if (listData2.length > 0) {
                        setEleInfoItem((item) => [...item, listData2]);
                    }
                    return data;
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    // 전력정보 등록
    function ElecIfoChange(e, id) {
        setEleInfo(elecInfo.map((smenu) => (smenu.companyElecId === id ? Object.assign(Object.assign({}, smenu), { value: e.target.value }) : smenu)));
    }
    function itemEditClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            let itemArr = [];
            for (let i = 0; i < elecInfo.length; i++) {
                itemArr.push({
                    elecCode: elecInfo[i].code,
                    value: elecInfo[i].value,
                });
            }
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/product/item/${itemInfo.itemIdPk}`,
                appQuery: {
                    roomId: recoilTree.room.roomId,
                    spgName: spg.spgName,
                    itemName: itemName,
                    panelName: panelName,
                    serialNo: serialNo,
                    manufacturer: manufacturer,
                    madeyyyyMM: dayjs(today).format("YYYYMM").toString(),
                    memo: memo,
                    elecInfo: itemArr,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (file.length > 0) {
                        uploadFileImage(data.body.itemIdPk);
                    }
                    else {
                        setReload(true);
                        PopClose("pop-edit-info");
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-info", type: CONST.TYPE_INNRE, divTag: t("라벨.기기가수정되었습니다") }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-info");
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
                else {
                    // need error handle
                    setErrorList(data.errorList);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제 API
    function ImgDelete(img) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/image/${img.imageId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-info", type: CONST.TYPE_ERROR, divTag: data.body }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setReloadState(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(img, index) {
        if (img.imageId) {
            ImgDelete(img);
        }
        else {
            setFile(file.filter((_, idx) => idx !== index));
        }
    }
    // 첨부파일 업로드
    function uploadFileImage(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let appPath = `?itemId=${itemId}`;
            const formData = new FormData();
            // 파일 데이터 저장
            file.map((files) => formData.append("files", files));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/images/item${appPath}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setFile([]);
                    setReload(true);
                    PopClose("pop-edit-info");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-info", type: CONST.TYPE_INNRE, divTag: t("라벨.기기가수정되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-info");
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.오류로인하여첨부파일이제거되어기기가수정되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    function onChangeItem(e) {
        setErrorList(errorList.filter((err) => err.field !== "itemName"));
        setItemName(e.target.value);
    }
    function onChangePanel(e) {
        setErrorList(errorList.filter((err) => err.field !== "panelName"));
        setPanelName(e.target.value);
    }
    function onChangeSerialNo(e) {
        setErrorList(errorList.filter((err) => err.field !== "serialNo"));
        setSerialNo(e.target.value);
    }
    function onChangeManufacturer(e) {
        setErrorList(errorList.filter((err) => err.field !== "manufacturer"));
        setManufacturer(e.target.value);
    }
    function onChangeTodayMonth(e) {
        setErrorList(errorList.filter((err) => err.field !== "madeyyyyMM"));
        if (e.target.value.length <= 7) {
            setToday(e.target.value);
        }
    }
    function PopClose(id) {
        CUTIL.IdScrollIntoView(id, "form__input");
        setEditReload(true);
        CUTIL.jsclose_Popup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body pb-0" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: recoilTree.company.companyName + " " + recoilTree.zone.zoneName }), _jsx("li", { children: recoilTree.subZone.subZoneId ? recoilTree.subZone.subZoneName : t("라벨.전체") }), _jsx("li", { children: recoilTree.room.roomId ? recoilTree.room.roomName : t("라벨.전체") })] })), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [_jsx("h2", { children: t("라벨.설비정보") }), !editReload && (_jsxs("ul", Object.assign({ className: "form__input scrollH h440 pb-30" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.분전소명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp26", value: (itemInfo && itemInfo.roomName) || "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select spg ${errorList.filter((err) => err.field === "companyId").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: spg && spg.spgName })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: spgInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg(info, null) }, { children: info.spgName }), "spgInfos_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${spg && spg.spgName == "배전반" ? "" : "star"}` }, { children: t("라벨.형명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { className: `${errorList.filter((err) => err.field === "itemName").length > 0 ? " input-error" : ""}`, type: "text", id: "inp22", placeholder: spg && spg.spgName == "배전반" ? "" : t("라벨.텍스트입력"), value: itemName || "", onChange: (e) => onChangeItem(e), disabled: spg && spg.spgName == "배전반" ? true : false }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "itemName").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${spg && (spg.spgName == "GIS" || spg.spgName == "유입식TR") ? "" : "star"}` }, { children: t("라벨.판넬명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "panelName").length > 0 ? " input-error" : ""}`, type: "text", id: "inp23", placeholder: spg && (spg.spgName == "GIS" || spg.spgName == "유입식TR") ? "" : t("라벨.텍스트입력"), value: panelName || "", onChange: (e) => onChangePanel(e), disabled: spg && (spg.spgName == "GIS" || spg.spgName == "유입식TR") ? true : false }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "panelName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${spg && spg.spgName == "배전반" ? "" : "star"}` }, { children: t("라벨.시리얼번호") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "serialNo").length > 0 ? " input-error" : ""}`, type: "text", id: "inp24", placeholder: t("라벨.텍스트입력"), value: serialNo || "", onChange: (e) => onChangeSerialNo(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "serialNo").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제조사") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "manufacturer").length > 0 ? " input-error" : ""}`, type: "text", id: "inp25", placeholder: t("라벨.텍스트입력"), value: manufacturer || "", onChange: (e) => onChangeManufacturer(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "manufacturer").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.제조년월") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "madeyyyyMM").length > 0 ? " input-error" : ""}`, type: "text", id: "inp28", placeholder: t("라벨.제조년월입력"), value: today.toString().replace(/(\d{4})(\d{1})/, "$1-$2") || "", onChange: (e) => onChangeTodayMonth(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "madeyyyyMM").map((err) => err.msg) }))] }))] }), elecInfo.map((item, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: `tit mt-0` }, { children: [langIds > 1 ? item.elecInfoNameEnglish : item.elecInfoName, " ", item.type < 2 && `(${item.unit})`, _jsx("br", {}), _jsxs("span", Object.assign({ className: "fontRegular" }, { children: ["(", item.code, ")"] }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: item.type < 2 ? (_jsx("input", { type: "text", id: "inp_" + idx, value: item.value || "", onChange: (e) => ElecIfoChange(e, item.companyElecId) })) : (
                                                // {(errorList.filter(err => (err.field === "companyId")).length > 0) ? " input-error" : ""}
                                                _jsxs("div", Object.assign({ className: `select elecinfo_${idx} `, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: item.value })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: langIds > 1
                                                                ? item.unitEn.map((list, index) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickElecInfo(item, list, item.idx, list.unitId, item.checked) }, { children: list.name }), "unitEn_" + index.toString())))
                                                                : item.unit.map((list, index) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickElecInfo(item, list, item.idx, list.unitId, item.checked) }, { children: list.name }), "unit_" + index.toString()))) })] }))) }))] }, "lsinfoEdit_" + idx.toString()))), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: _jsx("span", { children: t("라벨.첨부파일") }) })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", placeholder: t("라벨.사진첨부하세요"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file1" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", accept: "image/*", id: "file1", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부120MB") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: ImageUi.map((img, idx) => (_jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(img, idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "imgsEdit_" + idx.toString()))) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit " }, { children: t("라벨.메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: t("라벨.텍스트입력"), value: memo || "", onChange: (e) => setMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [memo ? memo.length : "0", " / 400"] }))] }))] })] })))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => PopClose("pop-edit-info") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => itemEditClick(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { itemInfo } = props;
    function DeviceDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/product/item/${itemInfo.itemIdPk}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.jsclose_Popup("pop-delete-image");
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.기기가삭제되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    if (data.errorList.field((err) => err.field == "itemId").length > 0) {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "필수 인자가 포함되지 않은 경우나 호출 인자값의 데이타 타입이 적절하지 않거나 허용된 범위를 벗어난 경우" }));
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "삭제를 실패했습니다" }));
                    }
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.기기를삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete-image") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            DeviceDelete(e);
                        } }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
